jQuery( document ).ready(function() {

  if($('.headermenuburger').length > 0) {

    $(".headermenuburger_checkbox").change(function() {
        if(this.checked) {
          $(".headermenuburger_menu").addClass("menu_visible");
        } else {
          $(".headermenuburger_menu").removeClass("menu_visible");
        }
    });

  }

});